import { resolveLink as t, resolveIcon as n } from "../../../helpers/index.js";
const i = (r) => ({
  items: r.properties?.areas?.map(
    (o) => o?.items.map((e) => ({
      text: e.content.properties?.text,
      link: e.content.properties?.link && t(e.content.properties?.link?.[0]),
      icon: e.content.properties?.ikon ? n(e.content.properties?.ikon) : void 0
    }))
  ).flat() || [],
  header: r.properties?.header,
  cta: r.properties?.link && t(r.properties.link[0]),
  variant: "topic"
});
export {
  i as clusterDeliveryApiParser
};
